import React from 'react';

const BasicChevron = ({ fill, size, className }) => (
	<svg
		width={size ? size : '9px'}
		height={size ? size : '6px'}
		viewBox="0 0 9 6"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		className={className}
	>
		<g stroke="none" stroke-width="1" fill={fill} fill-rule="evenodd">
			<g
				id="576-Nav-Hiw--"
				transform="translate(-121.000000, -328.000000)"
				fill={fill}
			>
				<polygon
					id="basic-chevron"
					transform="translate(125.220215, 330.637252) scale(1, -1) translate(-125.220215, -330.637252) "
					points="121 332.217159 125.223271 328 129.44043 332.217159 128.389196 333.274505 125.223271 330.10858 122.051234 333.274505"
				></polygon>
			</g>
		</g>
	</svg>
);

export default BasicChevron;
